import { sidebarConfig } from '@backstage/core-components';

// 256 open, 72 compact (the core default). The drawer insets every slot by 16
// on both sides.
const DRAWER_WIDTH_OPEN = 256;

// SidebarPage has no width prop. It reads the default SidebarConfigContext,
// which is this module object, for the padding of the pinned content, so the
// object is mutated at import. The core Sidebar gets its widths through the
// sidebarOptions prop below.
sidebarConfig.drawerWidthOpen = DRAWER_WIDTH_OPEN;

export const sidebarOptions = {
  drawerWidthOpen: DRAWER_WIDTH_OPEN,
};
